"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _InfoTooltip = _interopRequireDefault(require("../../../../components/InfoTooltip"));
var _surveys = _interopRequireDefault(require("./surveys.graphql"));
var _questprojects = _interopRequireDefault(require("./questprojects.graphql"));
var _window$cccisd;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Boilerplate = (_window$cccisd = window.cccisd) === null || _window$cccisd === void 0 ? void 0 : _window$cccisd.boilerplate;
var SurveyFields = function SurveyFields(props) {
  var surveyInfo = props.surveyInfo,
    useSurveyTitle = props.useSurveyTitle,
    duration = props.duration,
    surveyType = props.surveyType,
    audience = props.audience,
    showLanguage = props.showLanguage,
    infoResource = props.infoResource,
    previewText = props.previewText,
    showConfirmation = props.showConfirmation,
    questproject = props.questproject;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    surveys = _useState2[0],
    setSurveys = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    questprojects = _useState4[0],
    setQuestprojects = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    resources = _useState6[0],
    setResources = _useState6[1];

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE METHODS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    var loadQuestprojects = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _cccisdApollo.client.query({
                query: _questprojects["default"],
                fetchPolicy: 'network-only'
              });
            case 2:
              result = _context.sent;
              setQuestprojects(formatQuestprojects((0, _get2["default"])(result, "data.groups.questprojectList", [])));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function loadQuestprojects() {
        return _ref.apply(this, arguments);
      };
    }();
    var loadDocumentResources = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var params, resourcesRes;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              params = {
                published: 'both'
              };
              _context2.next = 3;
              return _cccisdAxios["default"].get(Boilerplate.route('api.resources.resource.index'), {
                params: params
              });
            case 3:
              resourcesRes = _context2.sent;
              setResources((0, _get2["default"])(resourcesRes, "data.data", []).filter(function (x) {
                return x.type === 'document';
              }));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function loadDocumentResources() {
        return _ref2.apply(this, arguments);
      };
    }();
    loadQuestprojects();
    loadDocumentResources();
    loadSurveys().then(function (res) {
      // Get updated survey info
      var selectedSurvey = res.data.flows.surveyList.find(function (survey) {
        return survey.surveyId === surveyInfo.value.surveyId;
      });
      if (selectedSurvey) {
        props.change('TestForm', 'surveyInfo', {
          surveyId: selectedSurvey.surveyId,
          surveyHandle: selectedSurvey.surveyHandle,
          surveyLabel: selectedSurvey.label,
          flowList: selectedSurvey.flowList,
          assignment: selectedSurvey.assignment
        });
      }
    });
  }, []);
  var loadSurveys = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(assignmentHandles) {
      var result;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _cccisdApollo.client.query({
              query: _surveys["default"],
              variables: {
                assignmentHandles: assignmentHandles
              },
              fetchPolicy: 'network-only'
            });
          case 2:
            result = _context3.sent;
            setSurveys((0, _get2["default"])(result, "data.flows.surveyList", []));
            return _context3.abrupt("return", result);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function loadSurveys(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var formatQuestprojects = function formatQuestprojects(data) {
    var formattedData = data.map(function (qp) {
      return {
        label: qp.group.label,
        value: qp.assignmentList.map(function (a) {
          return a.assignmentHandle;
        }).join(',')
      };
    });
    return formattedData;
  };

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function renderSurveyDropdown() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
      field: questproject,
      label: "Choose Quest Project"
    }, /*#__PURE__*/_react["default"].createElement("select", _extends({
      className: "form-select"
    }, (0, _cccisdReduxFormHelpers.domOnlyProps)(questproject), {
      style: {
        width: 'auto'
      },
      onChange: function onChange(e) {
        questproject.onChange(e.target.value);
        loadSurveys(e.target.value.split(','));
      }
    }), /*#__PURE__*/_react["default"].createElement("option", {
      value: questprojects.map(function (qp) {
        return qp.value;
      }).join(',')
    }, "All"), questprojects.map(function (qp) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: qp.value,
        value: qp.value
      }, qp.label);
    }))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
      field: surveyInfo,
      label: "Choose Survey"
    }, /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
      data: surveys,
      groupBy: function groupBy(item) {
        return item && item.assignment && item.assignment.label;
      },
      onChange: function onChange(e) {
        surveyInfo.onChange({
          surveyId: e.surveyId,
          surveyHandle: e.surveyHandle,
          surveyLabel: e.label,
          flowList: e.flowList,
          assignment: e.assignment
        });
      },
      placeholder: "--- Choose a Survey ---",
      textField: "label",
      value: surveyInfo.value,
      valueComponent: function valueComponent(_ref4) {
        var item = _ref4.item;
        if (item && item.surveyLabel) {
          var assignmentLabel = item.assignment && item.assignment.label ? " (".concat(item.assignment.label, ")") : '';
          return "".concat(item.surveyLabel).concat(assignmentLabel);
        }
        return surveyInfo.value.surveyLabel;
      },
      valueField: "surveyInfo"
    })));
  }
  function renderInfoResourceDropdown() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
      field: infoResource,
      label: /*#__PURE__*/_react["default"].createElement("span", null, "Choose Informational Resource", ' ', /*#__PURE__*/_react["default"].createElement(_InfoTooltip["default"], {
        tooltip: "Choose a document resource to link from this survey resource. Will show a \"Learn More\" link on the survey resource."
      }))
    }, /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
      data: resources,
      onChange: function onChange(e) {
        return infoResource.onChange({
          fileId: e.file_id,
          url: e.url,
          label: e.published_label
        });
      },
      placeholder: "--- Choose Informational Resource ---",
      textField: "published_label",
      value: infoResource.value,
      valueComponent: function valueComponent(_ref5) {
        var item = _ref5.item;
        if (item && item.label) {
          return "".concat(item.label);
        }
        return infoResource.value.label ? infoResource.value.label : 'Resource';
      },
      valueField: "infoResource"
    }));
  }
  var renderTitleToggle = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: useSurveyTitle
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: useSurveyTitle.value || false,
    onChange: useSurveyTitle.onChange,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Show survey title on resource card instead of resource title ")
  }));
  var renderDuration = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: duration,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Survey Duration ")
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(duration), {
    className: "form-control",
    placeholder: "eg. 15 minutes"
  })));
  var renderSurveyType = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: surveyType,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Survey Type ")
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(surveyType), {
    className: "form-control",
    placeholder: "eg. Survey/Direct Assessment"
  })));
  var renderAudience = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: audience,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Survey Audience ")
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(audience), {
    className: "form-control",
    placeholder: "eg. Students"
  })));
  var renderLanguageToggle = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: showLanguage
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: showLanguage.value || false,
    onChange: showLanguage.onChange,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Show Survey Language")
  }));
  var renderPreviewText = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: previewText,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Text to show above survey for preview ")
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(previewText), {
    className: "form-control",
    placeholder: "eg. This is a preview only. No responses will be collected or saved."
  })));
  var renderConfirmationToggle = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: showConfirmation
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: showConfirmation.value || false,
    onChange: showConfirmation.onChange,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Show Confirmation Modal", ' ', /*#__PURE__*/_react["default"].createElement(_InfoTooltip["default"], {
      tooltip: "Show a confirmation modal when selecting this survey for an assessment plan. This should be set to true if the survey has open ended questions."
    }))
  }));

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderSurveyDropdown(), renderTitleToggle, renderDuration, renderSurveyType, renderAudience, renderLanguageToggle, renderInfoResourceDropdown(), renderPreviewText, renderConfirmationToggle);
};
SurveyFields.propTypes = {
  duration: _propTypes["default"].object,
  surveyType: _propTypes["default"].object,
  audience: _propTypes["default"].object,
  surveyId: _propTypes["default"].object,
  showCourseSectionHeaders: _propTypes["default"].object,
  showCreditHours: _propTypes["default"].object,
  showMainIntroduction: _propTypes["default"].object,
  showLanguage: _propTypes["default"].object,
  useSurveyTitle: _propTypes["default"].object,
  previewText: _propTypes["default"].object,
  showConfirmation: _propTypes["default"].object
};
var _default = exports["default"] = (0, _reactRedux.connect)(null, {
  change: _reduxForm.change
})(SurveyFields);